import React from "react";
import { Collapse, Col, Row } from "reactstrap";
import { FormattedMessage, FormattedNumber } from "react-intl";
import CartStudentList from "./CartStudentList";
import { LicenseTypes } from "../../constants/LicenseTypes";
import { aplLicenseWillBeExtended } from "../../Utilities/licenseHelper";

class CartItem extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { collapse: false };
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  render() {
    const isAplItem =
      this.props.cartItem?.type === LicenseTypes.APLOnly ||
      this.props.cartItem?.type === LicenseTypes.PlusLicense;
    const addedStudents = this.props.cartItem?.addedStudents ?? [];
    const extendedStudentCount = isAplItem
      ? addedStudents.filter((student) =>
          aplLicenseWillBeExtended(student.licenses),
        ).length
      : 0;
    const someAplLicenseIsExtended = extendedStudentCount > 0;
    const allAplLicensesAreExtended =
      someAplLicenseIsExtended && extendedStudentCount === addedStudents.length;
    const productName =
      allAplLicensesAreExtended && this.props.cartItem?.nameWithoutStartDate
        ? this.props.cartItem.nameWithoutStartDate
        : this.props.cartItem?.name;

    return (
      <div
        style={{
          backgroundColor: this.props.isLatestAdded
            ? "rgba(77, 189, 116, .3)"
            : "white",
          backgroundBlendMode: "lighten",
          borderRadius: ".5em",
        }}
      >
        <Row className="p-2">
          <Col
            lg="9"
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
            }}
          >
            <Row className="ps-1">
              <Col>
                <strong>
                  <FormattedMessage id="Product" />
                </strong>
                : {productName}
              </Col>
            </Row>

            {someAplLicenseIsExtended && (
              <Row className="ps-1">
                <Col className="small text-body-secondary">
                  <FormattedMessage
                    id={
                      allAplLicensesAreExtended
                        ? "AplLicensesAreExtendedNote"
                        : "AplStartDateNote"
                    }
                  />
                </Col>
              </Row>
            )}

            <Row className="ps-1">
              <Col>
                <strong>
                  <FormattedMessage id="Quantity" />:{" "}
                </strong>
                {this.props.cartItem?.addedStudents?.length}
              </Col>
            </Row>

            <Row className="ps-1">
              <Col>
                <strong>
                  <FormattedMessage id="UnitPrice" />
                </strong>
                :{" "}
                <FormattedNumber
                  value={this.props.cartItem?.priceStudent ?? 0}
                  maximumFractionDigits={2}
                />{" "}
                kr
              </Col>
            </Row>
          </Col>

          <Col lg="3" className="pt-1">
            <Row className="pb-2 pe-1">
              <Col>
                <span>
                  {!this.props.readonly && (
                    <button
                      style={{ cursor: "pointer", width: "115px" }}
                      onClick={() => this.props.handleDeleteFromCart()}
                      type="button"
                      className="btn btn-sm btn-block btn-danger float-end"
                    >
                      <FormattedMessage id="Remove" /> <i className="fa fa-trash" />
                    </button>
                  )}
                </span>
              </Col>
            </Row>
            <Row className="pe-1 pt-1 pb-1">
              <Col>
                <span>
                  <button
                    style={{ cursor: "pointer", width: "115px" }}
                    onClick={this.toggle}
                    type="button"
                    className="btn btn-sm btn-block btn-primary float-end"
                  >
                    <FormattedMessage
                      id={this.state.collapse ? "HideStudentsCount" : "ShowStudentsCount"}
                      values={{ count: this.props.cartItem?.addedStudents?.length }}
                    />{" "}
                    <i className="fa fa-users" />
                  </button>
                </span>
              </Col>
            </Row>
          </Col>
          <Col>
            <Collapse isOpen={this.state.collapse}>
              <div className="ps-1 pe-1">
                <CartStudentList
                  addedStudentList={this.props.cartItem.addedStudents}
                  aplYears={isAplItem ? this.props.cartItem.years : null}
                  aplStartDate={this.props.cartItem.validFrom}
                />
              </div>
            </Collapse>
          </Col>
        </Row>
      </div>
    );
  }
}

export default CartItem;
